// Action Cable 消費者設定
import { createConsumer } from "@rails/actioncable"

// 建立 Action Cable 消費者
const consumer = createConsumer()

export default consumer